import { makeStyles } from 'tss-react/mui';

// Constants
import { UNAVAILABLE_IMAGE_OPACITY } from '../../../constants/ui';

import { styleCondition } from '../../../utils/styleCondition';
import { pickIf } from '../../../utils/pickIf';

const getButtons = (theme) => {
  return {
    '& #count-button': {
      height: 36,
    },
    '& #add-to-cart': {
      height: 36,
      fontSize: 14,
    },
    [theme.breakpoints.down('lg')]: {
      '& #count-button': {
        height: 44,
        '& input': {
          fontSize: 16,
        },
      },
      '& #add-to-cart': {
        height: 44,
        fontSize: 16,
      },
      '& #additionalInfo': {
        marginTop: 4,
      },
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(3),
      position: 'relative',
      '& #count-button': {
        '& input': {
          fontSize: 14,
        },
      },
      '& #add-to-cart': {
        fontSize: 14,
      },
      '& #additionalInfo': {
        height: 44,
        maxWidth: 86,
        position: 'absolute',
        marginLeft: 0,
        left: 156,
        fontSize: 16,
        marginTop: 0,
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...styleCondition(theme.isMobileDevice, {
        '& #count-button': {
          height: 44,
          '& input': {
            fontSize: 16,
          },
        },
        '& #add-to-cart': {
          height: 44,
          fontSize: 16,
        },
        '& #additionalInfo': {
          marginTop: 4,
        },
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...styleCondition(theme.isMobileDevice, {
        paddingBottom: theme.spacing(3),
        position: 'relative',
        '& #count-button': {
          '& input': {
            fontSize: 14,
          },
        },
        '& #add-to-cart': {
          fontSize: 14,
        },
        '& #additionalInfo': {
          height: 44,
          maxWidth: 86,
          position: 'absolute',
          marginLeft: 0,
          left: 156,
          fontSize: 16,
          marginTop: 0,
        },
      }),
    },
  };
};
export const useStyles = makeStyles()(
  (theme, { isKiteUser, isFavorite, isUnavailableForOrder } = {}) => ({
    reportableRow: { marginBottom: 10 },
    buttonsColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      flexGrow: 1,
      marginBottom: '1rem', // place for Over limit label
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    flexContainer: {
      display: 'flex',
      gap: 'min(10vw, 140px)',
      [theme.breakpoints.down('lg')]: {
        flex: 1,
        marginTop: theme.spacing(6),
        gap: 58,
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          flex: 1,
          marginTop: theme.spacing(6),
          gap: 58,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexDirection: 'column',
        }),
      },
    },
    descAndSize: {
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1.5),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginTop: theme.spacing(3),
          marginBottom: theme.spacing(1.5),
        }),
      },
    },
    description: {
      display: '-webkit-box',
      margin: 0,
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      [theme.breakpoints.down('lg')]: {
        width: '90%',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 22,
        width: '100%',
        overflow: 'visible',
        display: 'block',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          width: '90%',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          fontSize: 22,
          width: '100%',
          overflow: 'visible',
          display: 'block',
        }),
      },
    },
    stockNumber: {
      color: theme.palette.darkGrey,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(5),
      [theme.breakpoints.down('lg')]: {
        marginTop: 0,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginTop: 0,
        }),
      },
    },
    detailTitle: {
      color: theme.palette.darkGrey,
      fontWeight: 600,
      marginBottom: 6,
      '& span': {
        fontWeight: 400,
      },
    },
    left: {
      display: 'flex',
      flexDirection: 'column',
      flexBasis: '50%',
      [theme.breakpoints.down('lg')]: {
        flexBasis: '45%',
      },
      [theme.breakpoints.down('md')]: {
        flexBasis: '50%',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: '45%',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: '50%',
        }),
      },
    },
    right: {
      flexBasis: '50%',
      '& #inStock': {
        color: pickIf(
          isKiteUser,
          theme.palette.primary1,
          theme.palette.primary2,
        ),
      },
      [theme.breakpoints.down('lg')]: {
        flexBasis: '55%',
      },
      [theme.breakpoints.down('md')]: {
        flexBasis: '50%',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: '55%',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          flexBasis: '50%',
        }),
      },
    },
    mobileQuantity: {
      '& #inStock': {
        color: pickIf(
          isKiteUser,
          theme.palette.primary1,
          theme.palette.primary2,
        ),
      },
    },
    quantityContainer: {
      display: 'flex',
      gap: 90,
      [theme.breakpoints.down('lg')]: {
        gap: 50,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          gap: 50,
        }),
      },
    },
    buttons: getButtons(theme),
    fdmButton: {
      [theme.breakpoints.down('md')]: {
        width: 126,
        height: 36,
        paddingRight: 15,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          width: 126,
          height: 36,
          paddingRight: 15,
        }),
      },
    },
    addToFavorite: {
      color: `${theme.palette.primary1} !important`,
      fontWeight: 600,
      marginBottom: theme.spacing(2.25),
      marginTop: theme.spacing(3),
      padding: 0,
      fontSize: 14,
      '& svg': {
        marginRight: theme.spacing(1),
        '& path': {
          fill: pickIf(
            isFavorite,
            `${theme.palette.primary1} !important`,
            'unset',
          ),
          stroke: theme.palette.primary1,
        },
      },
      [theme.breakpoints.down('lg')]: {
        marginTop: theme.spacing(1.875),
        marginBottom: theme.spacing(1.25),
      },
      [theme.breakpoints.down('md')]: {
        margin: '10px auto',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginTop: theme.spacing(1.875),
          marginBottom: theme.spacing(1.25),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          margin: '10px auto',
        }),
      },
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      maxWidth: 290,
      '& img': {
        objectFit: 'contain',
        width: '100%',
        opacity: pickIf(isUnavailableForOrder, UNAVAILABLE_IMAGE_OPACITY, 1),
      },
      [theme.breakpoints.down('lg')]: {
        maxWidth: 363,
      },
      [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        margin: '-12px -12px 0 -12px',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          maxWidth: 363,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          maxWidth: '100%',
          margin: '-12px -12px 0 -12px',
        }),
      },
    },
    myRating: {
      justifyContent: 'center',
      marginTop: theme.spacing(1),
      color: '#929A92',
      maxWidth: 290,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 363,
      },
      [theme.breakpoints.down('md')]: {
        marginInline: 'auto',
        maxWidth: 'unset',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...styleCondition(theme.isMobileDevice, {
          maxWidth: 363,
        }),
      },

      [theme.breakpoints.downLandscape('md')]: {
        ...styleCondition(theme.isMobileDevice, {
          marginInline: 'auto',
          maxWidth: 'unset',
        }),
      },
    },
    rating: {
      fontSize: 18,
    },
  }),
);
